module.exports = __webpack_public_path__ + "fonts/Nexa_Bold.1dddbb66.woff";